import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { PageReady } from '@bingads-webui/page-ready';

export interface PageReadyTriggerProps {
  children?: ReactNode;
}

export const PageReadyTrigger = ({
  children,
}: PageReadyTriggerProps) => {
  useEffect(() => {
    PageReady.pageIsReady();
  }, []);

  return children || null;
};
